import React from 'react';
import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';
import style from './IsProtectedFromSyncCheckbox.module.scss';

interface IProps {
	toggleIsTaxPercentProtectedFromSync: () => void;
	isTaxPercentProtectedFromSync: boolean;
	isDisabled: boolean;
}

export const IsProtectedFromSyncCheckbox: React.FC<IProps> = React.memo(
	({ toggleIsTaxPercentProtectedFromSync, isTaxPercentProtectedFromSync, isDisabled }) => {
		return (
			<Form.Item
				className={style.container}
				name="isTaxPercentProtectedFromSync"
				data-test="IsProtectedFromSyncCheckbox">
				<Checkbox
					onChange={toggleIsTaxPercentProtectedFromSync}
					checked={isTaxPercentProtectedFromSync}
					disabled={isDisabled}>
					<Text translationNameSpace="form" translationKey="protectFromSyncLabel" asFragment={true} />
				</Checkbox>
			</Form.Item>
		);
	},
);
